import dayjs from 'dayjs';

export function getDatesBetween(startDate: Date, endDate: Date) {
    const dates: dayjs.Dayjs[] = [];
    let currentDate = dayjs(startDate);

    while (currentDate.isBefore(dayjs(endDate).add(1, 'day'))) {
        dates.push(currentDate);
        currentDate = currentDate.add(1, 'day');
    }

    return dates;
}

export function dateToISODateString(date: Date | null): string | null {
    return date instanceof Date && !Number.isNaN(date.getTime())
        ? date.toISOString().slice(0, 10)
        : null;
}

export function isoDateStringToDate(val: string | null): Date | null {
    return val ? new Date(val) : null;
}

export const getDateString = dateToISODateString;
